import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getFeatureFlag = {
  name: "getFeatureFlag" as const,
  input: z.object({
    flagKey: createEnum(FeatureFlagKey),
    defaultValue: z.boolean().nullish(),
  }),
  output: z.object({ enabled: z.boolean() }),
};
